import { api } from './client'
import { Product, Category } from '../types'

export async function getCategories(): Promise<Category[]> {
  const res = await api.get('/api/v1/products/categories')
  return res.data
}

export async function getProducts(params?: {
  category_id?: number
  search?: string
  is_active?: boolean
  offset?: number
  limit?: number
}): Promise<{ items: Product[]; total: number }> {
  const res = await api.get('/api/v1/products', { params })
  return res.data
}

export async function getProduct(id: number): Promise<Product> {
  const res = await api.get(`/api/v1/products/${id}`)
  return res.data
}

export async function createProduct(data: {
  name_ru: string; name_uz: string; price: number
  category_id?: number; description_ru?: string
  description_uz?: string; image_path?: string
  extra_images?: string[]; notify_clients?: boolean
}): Promise<Product> {
  const res = await api.post('/api/v1/products', data)
  return res.data
}

export async function updateProduct(id: number, data: Partial<{
  name_ru: string; name_uz: string; price: number
  category_id: number; description_ru: string
  description_uz: string; image_path: string; is_active: boolean
}>): Promise<Product> {
  const res = await api.patch(`/api/v1/products/${id}`, data)
  return res.data
}

// Backend has no DELETE — soft-delete by setting is_active=false
export async function deactivateProduct(id: number): Promise<Product> {
  return updateProduct(id, { is_active: false })
}

export async function uploadProductImage(file: File): Promise<{ image_path: string }> {
  const form = new FormData()
  form.append('file', file)
  const res = await api.post('/api/v1/upload/product-image', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return res.data
}
